import { render } from "./RoutePenanganan.vue?vue&type=template&id=00a7e32f"
import script from "./RoutePenanganan.vue?vue&type=script&lang=js"
export * from "./RoutePenanganan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__